"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
var Header;
(function (Header) {
    Header["FREDHOPPER_SEGMENT"] = "x-ab-fredhopper-segment";
    Header["COOKIE_LEVEL"] = "x-cookie-level";
    Header["COOKIE_LEVEL_SET"] = "x-cookie-level-set";
    Header["COOKIE_CONSENT_SETTING"] = "x-cookie-consent-setting";
    Header["VARNISH_IP"] = "x-varnish-ip";
    Header["ESI_PARENT_URL"] = "x-esi-parent";
})(Header || (exports.Header = Header = {}));
//# sourceMappingURL=HeaderEnums.js.map